const info = 
{
    title: "Fourth Wall",
    type: "Web Series"
};

export default info;